import React from "react";
import { Home } from "lucide-react";
import { DS } from "../designSystem";

// Tela pública de pré-visualização de um ebook (rota /familia/ebooks/<slug>).
// Não exige login: qualquer visitante (e o Google) pode ver capa, titulo,
// autor e capitulos. O login só é pedido quando a pessoa toca em
// "Começar a leitura" (ver onStartReading, que reaproveita o openEbook()
// existente e a mesma logica de showProfilePrompt).
export default function EbookLanding({
  ebook,
  onStartReading,
  onBack,
  renderBottomNav,
  isMobile,
  isTablet,
  isDesktop,
  styles
}) {
  const {
    containerStyle,
    fixedTopBarStyle,
    buttonReset,
    pageContentStyle,
    h1Style,
    overflowGuardStyle
  } = styles;

  if (!ebook) return null;

  const accent = ebook.coverColor || "#E6B15A";
  const chapterCount = Array.isArray(ebook.chapters) ? ebook.chapters.length : 0;

  return (
    <div style={containerStyle}>
      <div style={{ ...fixedTopBarStyle, borderBottom: `2px solid ${accent}` }}>
        <button onClick={onBack} style={{ ...buttonReset, fontSize: 24, color: "#9CA3AF", marginRight: 20 }}>←</button>
        <span style={{ fontSize: 11, fontWeight: 700, color: "#FFFFFF", textTransform: "uppercase", letterSpacing: 1.5, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{ebook.title}</span>
        <a href="/" aria-label="Voltar para o site institucional" title="Início do site" style={{ marginLeft: "auto", display: "inline-flex", alignItems: "center", justifyContent: "center", width: 34, height: 34, borderRadius: 999, color: "#9CA3AF", textDecoration: "none", flexShrink: 0 }}>
          <Home size={18} />
        </a>
      </div>

      <div style={pageContentStyle}>
        <article style={{ maxWidth: 720, width: "100%", boxSizing: "border-box", margin: "0 auto" }}>
          <div style={{ display: "grid", gridTemplateColumns: isMobile ? "112px minmax(0, 1fr)" : isTablet ? "168px minmax(0, 1fr)" : "196px minmax(0, 1fr)", gap: isTablet ? 26 : 16, alignItems: "start", marginBottom: 28 }}>
            <img
              src={ebook.coverImage}
              alt={`Capa do ebook ${ebook.title}`}
              style={{ width: "100%", height: "auto", aspectRatio: "3 / 4.3", objectFit: "cover", objectPosition: "top center", boxShadow: "0 22px 38px rgba(0,0,0,0.44)" }}
            />
            <div>
              <p style={{ margin: "0 0 10px", fontSize: 11, letterSpacing: 2, color: accent, textTransform: "uppercase", fontWeight: 900 }}>Ebook gratuito</p>
              <h1 style={{ ...h1Style, margin: 0, fontSize: isDesktop ? 42 : isTablet ? 34 : 27, lineHeight: 1.06, color: "#ffffff", fontWeight: 900 }}>{ebook.title}</h1>
              <p style={{ margin: "10px 0 4px", fontSize: 15, lineHeight: 1.55, color: "#c7d1e4" }}>{ebook.subtitle}</p>
              <p style={{ margin: "0 0 18px", fontSize: 12, color: "#7f8da3", fontWeight: 700 }}>{ebook.author}{ebook.pages ? ` · ${ebook.pages} páginas` : ""}</p>
              <button
                onClick={onStartReading}
                style={{ ...buttonReset, minHeight: 48, padding: "0 22px", border: `1px solid ${accent}`, background: accent, color: "#111827", fontSize: 12, fontWeight: 950, textTransform: "uppercase", letterSpacing: 1 }}
              >
                Começar a leitura
              </button>
            </div>
          </div>

          <section style={{ ...overflowGuardStyle, background: "linear-gradient(180deg, rgba(255,255,255,0.055), rgba(255,255,255,0.02))", border: "1px solid rgba(255,255,255,0.12)", borderTop: `4px solid ${accent}`, padding: isTablet ? 22 : 16, marginBottom: 20 }}>
            <p style={{ margin: "0 0 8px", fontSize: 11, letterSpacing: 2.2, color: "#8fa0bf", textTransform: "uppercase", fontWeight: 900 }}>Sobre este ebook</p>
            <p style={{ margin: 0, fontSize: 14, lineHeight: 1.65, color: "#c7d1e4" }}>
              {ebook.readerQuestion || `${ebook.title} é uma leitura de ${ebook.author}, disponível gratuitamente dentro do app Família Mosaico. Crie seu acesso para acompanhar a leitura, salvar seu progresso e fazer anotações.`}
            </p>
          </section>

          {chapterCount > 0 && (
            <section style={{ marginBottom: 24 }}>
              <p style={{ margin: "0 0 10px", fontSize: 11, letterSpacing: 2.2, color: "#8fa0bf", textTransform: "uppercase", fontWeight: 900 }}>{chapterCount === 1 ? "Capítulo" : "Capítulos"}</p>
              <ol style={{ margin: 0, padding: 0, listStyle: "none", display: "grid", gap: 8 }}>
                {ebook.chapters.map((chapter, index) => (
                  <li key={chapter} style={{ padding: "12px 14px", background: "rgba(255,255,255,0.045)", border: "1px solid rgba(255,255,255,0.1)", color: "#e5eaf3", fontSize: 13, fontWeight: 700, display: "flex", gap: 10, alignItems: "center" }}>
                    <span style={{ color: accent, fontWeight: 950 }}>{String(index + 1).padStart(2, "0")}</span>
                    {chapter}
                  </li>
                ))}
              </ol>
            </section>
          )}

          <section style={{ textAlign: "center", padding: isTablet ? "28px 24px" : "22px 16px", background: "#111827", border: `1px solid ${accent}` }}>
            <p style={{ margin: "0 0 14px", fontSize: 14, lineHeight: 1.6, color: "#aeb9ca" }}>
              A leitura completa fica dentro do app, com seu progresso salvo depois de um cadastro rápido e gratuito.
            </p>
            <button
              onClick={onStartReading}
              style={{ ...buttonReset, minHeight: 48, padding: "0 22px", border: `1px solid ${accent}`, background: accent, color: "#111827", fontSize: 12, fontWeight: 950, textTransform: "uppercase", letterSpacing: 1 }}
            >
              Começar a leitura
            </button>
          </section>
        </article>
      </div>
      {renderBottomNav && renderBottomNav()}
    </div>
  );
}
